import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav className="flex items-center space-x-2 text-sm text-light/60">
      {items.map((item, index) => (
        <React.Fragment key={item.label}>
          {index > 0 && <ChevronRight className="w-4 h-4" />}
          {item.href ? (
            <Link
              to={item.href}
              className="hover:text-light transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-light">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}